import './PrintStudentLabels.css';

import {
  Button,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core';
import JsBarcode from 'jsbarcode';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { selectCoordinators } from '../../redux/admin/admin.selectors';

const INITIAL_COORDINATOR = null;

const CLASSROOM_VALUES = ['all', 1, 2, 3, 4, 5, 6, 7, 8, 9];

const INITIAL_STATE = {
  classroom: 'all',
};

const Label = ({ children }) => {
  return <div className='label'>{children}</div>;
};

const EAN = ({ data }) => {
  const id = 'ean-13-' + data;

  useEffect(() => {
    try {
      JsBarcode('#' + id, data, {
        format: 'ean13',
        height: 80,
        margin: 0,
        marginLeft: 10,
        marginRight: 10,
      });
    } catch (e) {
      console.error(e);
    }
  }, [id, data]);

  return <svg id={id} />;
};

const StudentInfo = ({ name }) => {
  return (
    <div className='student-info'>
      <span>{name}</span>
    </div>
  );
};

const openPrintDialog = () => {
  window.print();
};

const PrintStudentLabels = () => {
  const { coordinatorId } = useParams();

  const coordinators = useSelector(selectCoordinators);
  const [coordinator, setCoordinator] = useState(INITIAL_COORDINATOR);
  const [state, setState] = useState(INITIAL_STATE);

  const handleChange = useCallback(
    (key) => {
      return function ({ target: { value } }) {
        setState((state) => ({
          ...state,
          [key]: value,
        }));
      };
    },
    [setState]
  );

  useEffect(() => {
    setCoordinator(coordinators[coordinatorId] || null);
  }, [coordinators, coordinatorId]);

  const constructEanCode = ({ classroom, test_id }) => {
    if (!test_id || !classroom) {
      return '000000000000';
    }

    return '0' + classroom + test_id;
  };

  return (
    <>
      <Container className='container'>
        <Typography variant='h4'>
          {`${coordinator?.title} ${coordinator?.firstname} ${coordinator?.lastname}`}
        </Typography>

        <Typography variant='h6'>{`${coordinator?.schoolName}`}</Typography>

        <Typography>{`${coordinator?.street}`}</Typography>

        <Typography>{`${coordinator?.city} ${coordinator?.postalCode}`}</Typography>

        <Typography>{`${coordinator?.email}`}</Typography>

        <Typography>{`${coordinator?.phone}`}</Typography>

        <FormControl fullWidth style={{ marginBottom: 20 }}>
          <InputLabel id='select-classroom-label'>Ročník</InputLabel>

          <Select
            fullWidth
            id='select-classroom'
            labelId='select-classroom-label'
            onChange={handleChange('classroom')}
            value={state.classroom}
          >
            {CLASSROOM_VALUES.map((classroom) => (
              <MenuItem key={classroom} value={classroom}>
                {`${classroom}. ročník`}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button color='primary' onClick={openPrintDialog} variant='contained'>
          Tlačiť štítky
        </Button>
      </Container>

      <div className='student-labels'>
        {coordinator &&
          coordinator.students &&
          Object.values(coordinator.students)
            .filter(
              (student) =>
                student.classroom === state.classroom ||
                state.classroom === 'all'
            )
            .map((student) => (
              <Label key={student.test_id}>
                <EAN data={constructEanCode(student)} />

                <StudentInfo
                  name={student.firstname + ' ' + student.lastname}
                />
              </Label>
            ))}
      </div>
    </>
  );
};

export default PrintStudentLabels;
